import { CheckCircle2, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import { CONTACT } from '../data/siteData';

export default function SchoolEvents() {
  return (
    <>
      <Seo title="School Pumpkin Patch Events" description="Jonny's Towing delivers immersive school pumpkin patch experiences with themed transportation and decorations in Richmond, BC." image="/images/school-pumpkin-patch.jpg" />
      <PageHero
        eyebrow="DreamCrafters school experiences"
        title="Pumpkin patches. Delivered."
        description="No buses and no field trip logistics—just an immersive pumpkin-patch experience created directly in your schoolyard."
        image="/images/school-pumpkin-patch.jpg"
      >
        <a className="button button--primary" href={`mailto:${CONTACT.email}?subject=School%20Pumpkin%20Patch%20Inquiry`}><Mail size={18} /> Request a school date</a>
      </PageHero>
      <section className="section container prose-grid">
        <article className="prose-copy">
          <span className="eyebrow">What to expect</span>
          <h2>A memorable fall experience without leaving school.</h2>
          <p>Our DreamCrafters take the magic of a pumpkin patch directly to your school. We collect the school’s pumpkin order from the selected farm, deliver it using a themed flatbed and work with school volunteers to transform the space.</p>
          <ul className="check-list large-list">
            <li><CheckCircle2 /> Themed flatbed delivery of the school’s pumpkin order</li>
            <li><CheckCircle2 /> Setup support from our staff and school volunteers</li>
            <li><CheckCircle2 /> A pumpkin for each participating student</li>
            <li><CheckCircle2 /> Choice of cute seasonal or pirate-themed decorations</li>
            <li><CheckCircle2 /> An immersive schoolyard experience</li>
          </ul>
          <p>Dates are limited and October fills quickly. Schools should contact us well in advance with expected student count, preferred dates and site-access information.</p>
          <p>Community members who want to help support these experiences can offer a scrap vehicle, scrap metal or other suitable materials.</p>
          <Link className="button button--secondary" to="/community/halloween">🎃 Explore Halloween School Donations</Link>
        </article>
        <aside className="image-panel"><img src="/images/school-pumpkin-patch.jpg" alt="Pumpkins and giant skeleton at a Jonny's school event" /></aside>
      </section>
    </>
  );
}
